module.exports = __webpack_public_path__ + "media/assets/icons/sign-icon-purple-f48078b3265dfbfed108e372f492893f.png";